// import React, { useState, useEffect } from "react";
// import { EyeIcon, EyeOffIcon } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import Clean from "../assets/clean.png"; // Update to the correct path for your image
// import axios from "axios";
// import { BaseUrl } from "../App";
// 
// import { Circles } from "react-loader-spinner";


// const LoginPage = () => {
//   const [email, setEmail] = useState(""); // State for email input
//   const [password, setPassword] = useState(""); // State for password input
//   const [error, setError] = useState(""); // State for error message
//   // const [loading, setLoading] = useState(false); // Loading state
//   const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state
//   const navigate = useNavigate(); // Hook to navigate to different routes
//   const [userType, setUserType] = useState(""); // State to store user type
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     // Debugging: Log to confirm if the states are set correctly
//     console.log("isLoggedIn:", isLoggedIn, "userType:", userType);

//     // Ensure navigation happens once login is successful and userType is set
//     if (isLoggedIn && userType) {
//       if (userType === "admin") {
//         navigate("/admin"); // Navigate to Admin page
//       } else if (userType === "staff") {
//         navigate("/staff"); // Navigate to Staff page
//       } else if (userType === "client") {
//         navigate("/user"); // Navigate to User page
//       }
//     }
//   }, [isLoggedIn, userType, navigate]); // Trigger effect when isLoggedIn or userType changes
//   const handleLogin = async (e) => {
//     e.preventDefault(); // Prevent default form submission

//     if (!email || !password) {
//       setError("Please fill in both email and password.");
//       return;
//     }

//     setLoading(true);
//     setError(""); // Reset error message

//     try {
//       // Sending API request to check login credentials
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/check_login.php`,
//         {
//           action: "check_login",
//           api_key: 1,
//           email: email,
//           password: password,
//         }
//       );

//       // Log the full API response to check the structure
//       console.log("Full API Response:", response.data);

//       if (response.data.status === "true") {
//         setError(""); // Reset error if login is successful

//         const userType = response.data?.usertype; // Get userType from response
//         const userId = response.data?.userId; // Get userId from response

//         console.log("User Type:", userType);
//         console.log("User ID:", userId); // Log userId

//         if (userType && userId) {
//           setUserType(userType);
//           setIsLoggedIn(true);

//           // Store userId and userType in localStorage
//           // localStorage.setItem('userId', userId);
//           // localStorage.setItem('userType', userType);
//           // localStorage.setItem('isLoggedIn', 'true'); //
//           sessionStorage.setItem("userId", userId);
//           sessionStorage.setItem("userType", userType);
//           sessionStorage.setItem("isLoggedIn", "true"); // Store in sessionStorage

//           // Optionally, navigate to the respective panel
//           if (userType === "admin") {
//             navigate("/admin");
//           } else if (userType === "staff") {
//             navigate("/staff");
//           } else if (userType === "client") {
//             navigate("/user");
//           }
//         } else {
//           setError("User type or user ID not found in the response.");
//         }
//       } else {
//         setError(response.data.response || "Invalid email or password.");
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again later.");
//       console.error("Login error:", error.response || error);
//     } finally {
//       setLoading(false); // Reset loading state
//     }
//   };

//   return (
//     <div>
//       {loading ? (
//         <div className="flex flex-col items-center justify-center min-h-screen">
//           <Circles height="80" width="80" color="grey" ariaLabel="loading" />
//           <h1 className="mt-2">Please wait...</h1>
//         </div>
//       ) : (
//         <div className="relative min-h-screen flex flex-col sm:flex-row">
//           {/* Left Section - Gray background */}
//           <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>
//           <div className="absolute bottom-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>
//           <div className="absolute  left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>

//           <div className="w-full sm:w-1/2 bg-gray-50 flex justify-center items-center">
//             {/* You can add content here */}
//           </div>

//           {/* Right Section - Green background */}
//           <div className="w-full sm:w-1/2 bg-blue-600 flex justify-center items-center">
//             {/* Center the card between gray and green */}
//             <div
//               className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex w-[80%] max-w-4xl shadow-lg border-4 border-blue-800 rounded-3xl overflow-hidden
//     flex-col sm:flex-row"
//             >
//               {/* Left Section inside the card (Gray section in the card) */}
//               <div className="w-full sm:w-1/2 bg-white flex flex-col justify-center items-center p-5">
//                 <img
//                   src={Clean}
//                   alt="Illustration"
//                   className=" mb-1 hidden sm:block"
//                 />{" "}
//                 {/*Conditionally hide the image*/}
//                 <p className="text-lg text-gray-700 text-center hidden sm:block">
//                   Welcome to{" "}
//                   <span className="text-orange-500 font-bold">Mega Clean</span>
//                 </p>
//                 <p className="text-lg text-gray-700 text-center sm:hidden">
//                   Welcome to{" "}
//                   <span className="text-orange-500 font-bold">Mega Clean</span>
//                 </p>
//                 <img src={Clean} alt="Illustration" className=" sm:hidden" />
//               </div>
//               {/* Right Section inside the card (Green section in the card) */}
//               <div className="w-full sm:w-1/2 bg-blue-800 text-white p-8 flex flex-col justify-center">
//                 <h2 className="text-3xl font-bold mb-6 text-center  ">Login</h2>
//                 {/* Form to capture login details */}
//                 <form onSubmit={handleLogin} className="space-y-6">
//                   <div>
//                     <label
//                       htmlFor="email"
//                       className="block text-sm font-medium"
//                     >
//                       Email address
//                     </label>
//                     <input
//                       type="email"
//                       id="email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)} // Update email state on change
//                       className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black"
//                       placeholder="Enter your email"
//                     />
//                   </div>
//                   <div className="relative">
//                     <label
//                       htmlFor="password"
//                       className="block text-sm font-medium"
//                     >
//                       Password
//                     </label>
//                     <input
//                       type={showPassword ? "text" : "password"} // Toggle type
//                       id="password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black pr-10"
//                       placeholder="Enter your password"
//                     />
//                     <button
//                       type="button"
//                       className="absolute right-3 top-12 transform -translate-y-1/2 text-gray-500"
//                       onClick={() => setShowPassword(!showPassword)}
//                     >
//                       {showPassword ? (
//                         <EyeOffIcon size={20} />
//                       ) : (
//                         <EyeIcon size={20} />
//                       )}
//                     </button>
//                   </div>

//                   <div className="flex justify-center">
//                     <button
//                       type="submit"
//                       className="w-32 bg-red-400 text-white py-2 rounded-lg shadow-md hover:bg-orange-600 text-sm flex justify-center items-center"
//                     >
//                       Log in
//                     </button>
//                   </div>
//                 </form>
//                 {error && (
//                   <p className="text-center text-sm mt-4 text-red-500">
//                     {error}
//                   </p> // Display error message if any
//                 )}
//                 {/* <p className="text-center text-sm mt-4 text-orange-500 cursor-pointer hover:underline">
//                   Forgot password?
//                 </p> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LoginPage;



/// fooget password

// import React, { useState, useEffect } from "react";
// import { EyeIcon, EyeOffIcon } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import Clean from "../assets/clean.png";
// import axios from "axios";
// import { BaseUrl } from "../App";
// 
// import { Circles } from "react-loader-spinner";


// const LoginPage = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const navigate = useNavigate();
//   const [userType, setUserType] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   // Popup states
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [popupEmail, setPopupEmail] = useState("");
//   const [popupPassword, setPopupPassword] = useState("");
//   const [showPopupPassword, setShowPopupPassword] = useState(false);

//   useEffect(() => {
//     if (isLoggedIn && userType) {
//       if (userType === "admin") navigate("/admin");
//       else if (userType === "staff") navigate("/staff");
//       else if (userType === "client") navigate("/user");
//     }
//   }, [isLoggedIn, userType, navigate]);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     if (!email || !password) {
//       setError("Please fill in both email and password.");
//       return;
//     }
//     setLoading(true);
//     setError("");
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/check_login.php`,
//         { action: "check_login", api_key: 1, email, password }
//       );
//       if (response.data.status === "true") {
//         const userType = response.data?.usertype;
//         const userId = response.data?.userId;
//         if (userType && userId) {
//           setUserType(userType);
//           setIsLoggedIn(true);
//           sessionStorage.setItem("userId", userId);
//           sessionStorage.setItem("userType", userType);
//           sessionStorage.setItem("isLoggedIn", "true");
//         } else {
//           setError("User type or user ID not found.");
//         }
//       } else {
//         setError(response.data.response || "Invalid email or password.");
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again.");
//       console.error("Login error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Forgot Password Handler
//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     if (!popupEmail || !popupPassword) {
//       setError("Please enter both email and new password.");
//       setSuccessMessage("");
//       return;
//     }

//     setLoading(true);
//     setError("");
//     setSuccessMessage("");

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/staff.php`,
//         {
//           action: "update_staff",
//           api_key: "1",
//           id:"5",
//           email: popupEmail,
//           pass: popupPassword,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.status === "true") {
//         setSuccessMessage("Password reset successfully!");
//         setError("");
//         setIsPopupOpen(false);
//         setPopupEmail("");
//         setPopupPassword("");
//       } else {
//         setError(response.data.response || "Failed to reset password.");
//         setSuccessMessage("");
//       }
//     } catch (error) {
//       console.error("Forgot password error:", error);
//       setError("An error occurred. Please try again.");
//       setSuccessMessage("");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       {loading ? (
//         <div className="flex flex-col items-center justify-center min-h-screen">
//           <Circles height="80" width="80" color="grey" ariaLabel="loading" />
//           <h1 className="mt-2">Please wait...</h1>
//         </div>
//       ) : (
//         <div className="relative min-h-screen flex flex-col sm:flex-row">
//           {/* Background elements */}
//           <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>
//           <div className="absolute bottom-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>
//           <div className="absolute left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>

//           <div className="w-full sm:w-1/2 bg-gray-50 flex justify-center items-center"></div>

//           <div className="w-full sm:w-1/2 bg-blue-600 flex justify-center items-center">
//             <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex w-[80%] max-w-4xl shadow-lg border-4 border-blue-800 rounded-3xl overflow-hidden flex-col sm:flex-row">
//               <div className="w-full sm:w-1/2 bg-white flex flex-col justify-center items-center p-5">
//                 <img src={Clean} alt="Illustration" className="mb-1 hidden sm:block" />
//                 <p className="text-lg text-gray-700 text-center hidden sm:block">
//                   Welcome to <span className="text-orange-500 font-bold">Mega Clean</span>
//                 </p>
//                 <p className="text-lg text-gray-700 text-center sm:hidden">
//                   Welcome to <span className="text-orange-500 font-bold">Mega Clean</span>
//                 </p>
//                 <img src={Clean} alt="Illustration" className="sm:hidden" />
//               </div>
//               <div className="w-full sm:w-1/2 bg-blue-800 text-white p-8 flex flex-col justify-center">
//                 <h2 className="text-3xl font-bold mb-6 text-center">Login</h2>
//                 <form onSubmit={handleLogin} className="space-y-6">
//                   <div>
//                     <label htmlFor="email" className="block text-sm font-medium">
//                       Email address
//                     </label>
//                     <input
//                       type="email"
//                       id="email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black"
//                       placeholder="Enter your email"
//                     />
//                   </div>
//                   <div className="relative">
//                     <label htmlFor="password" className="block text-sm font-medium">
//                       Password
//                     </label>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       id="password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black pr-10"
//                       placeholder="Enter your password"
//                     />
//                     <button
//                       type="button"
//                       className="absolute right-3 top-12 transform -translate-y-1/2 text-gray-500"
//                       onClick={() => setShowPassword(!showPassword)}
//                     >
//                       {showPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
//                     </button>
//                   </div>
//                   <div className="flex justify-center">
//                     <button
//                       type="submit"
//                       className="w-32 bg-red-400 text-white py-2 rounded-lg shadow-md hover:bg-orange-600 text-sm flex justify-center items-center"
//                     >
//                       Log in
//                     </button>
//                   </div>
//                 </form>
//                 {error && <p className="text-center text-sm mt-4 text-red-500">{error}</p>}
//                 {successMessage && (
//                   <p className="text-center text-sm mt-4 text-green-500">{successMessage}</p>
//                 )}
//                 <p
//                   className="text-center text-sm mt-4 text-orange-500 cursor-pointer hover:underline"
//                   onClick={() => setIsPopupOpen(true)}
//                 >
//                   Forgot password?
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Popup Modal */}
//           {isPopupOpen && (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//               <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//                 <h3 className="text-xl font-bold text-gray-800 mb-4">Reset Password</h3>
//                 <form onSubmit={handleForgotPassword} className="space-y-4">
//                   <div>
//                     <label htmlFor="popupEmail" className="block text-sm font-medium text-gray-700">
//                       Email address
//                     </label>
//                     <input
//                       type="email"
//                       id="popupEmail"
//                       value={popupEmail}
//                       onChange={(e) => setPopupEmail(e.target.value)}
//                       className="w-full mt-2 px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 text-black"
//                       placeholder="Enter your email"
//                     />
//                   </div>
//                   <div className="relative">
//                     <label htmlFor="popupPassword" className="block text-sm font-medium text-gray-700">
//                       New Password
//                     </label>
//                     <input
//                       type={showPopupPassword ? "text" : "password"}
//                       id="popupPassword"
//                       value={popupPassword}
//                       onChange={(e) => setPopupPassword(e.target.value)}
//                       className="w-full mt-2 px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 text-black pr-10"
//                       placeholder="Enter new password"
//                     />
//                     <button
//                       type="button"
//                       className="absolute right-3 top-10 transform -translate-y-1/2 text-gray-500"
//                       onClick={() => setShowPopupPassword(!showPopupPassword)}
//                     >
//                       {showPopupPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
//                     </button>
//                   </div>
//                   {error && <p className="text-sm text-red-500">{error}</p>}
//                   {successMessage && <p className="text-sm text-green-500">{successMessage}</p>}
//                   <div className="flex justify-end space-x-2">
//                     <button
//                       type="button"
//                       className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
//                       onClick={() => {
//                         setIsPopupOpen(false);
//                         setPopupEmail("");
//                         setPopupPassword("");
//                         setError("");
//                         setSuccessMessage("");
//                       }}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600"
//                     >
//                       Reset Password
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default LoginPage;
/************************************* */



import React, { useState, useEffect } from "react";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Clean from "../assets/clean.png";
import axios from "axios";
import { BaseUrl } from "../App";

// import { Circles } from "react-loader-spinner";

import { FadeLoader } from 'react-spinners';

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // Popup states
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupEmail, setPopupEmail] = useState("");

  useEffect(() => {
    if (isLoggedIn && userType) {
      if (userType === "admin") navigate("/admin");
      else if (userType === "staff") navigate("/staff");
      else if (userType === "client") navigate("/user");
    }
  }, [isLoggedIn, userType, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please fill in both email and password.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/check_login.php`,
        { action: "check_login", api_key: "1", email, password }
      );
      if (response.data.status === "true") {
        const userType = response.data?.usertype;
        const userId = response.data?.userId;
        if (userType && userId) {
          setUserType(userType);
          setIsLoggedIn(true);
          sessionStorage.setItem("userId", userId);
          sessionStorage.setItem("userType", userType);
          sessionStorage.setItem("isLoggedIn", "true");
        } else {
          setError("User type or user ID not found.");
        }
      } else {
        setError(response.data.response || "Invalid email or password.");
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Forgot Password Handler
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!popupEmail) {
      setError("Please enter your email.");
      setSuccessMessage("");
      return;
    }

    setLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/check_login.php`,
        {
          action: "forgot_password",
          api_key: "1",
          email: popupEmail,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "true") {
        setSuccessMessage("A password reset link has been sent to your email.");
        setError("");
        setIsPopupOpen(false);
        setPopupEmail("");
      } else {
        setError(response.data.response || "Failed to send reset link.");
        setSuccessMessage("");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setError("An error occurred. Please try again.");
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
   
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         

        <div className="relative min-h-screen flex flex-col sm:flex-row">
          {/* Background elements */}
          <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>
          <div className="absolute bottom-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>
          <div className="absolute left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50 hidden sm:block"></div>

          <div className="w-full sm:w-1/2 bg-gray-50 flex justify-center items-center"></div>

          <div className="w-full sm:w-1/2 bg-blue-600 flex justify-center items-center">
            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex w-[80%] max-w-4xl shadow-lg border-4 border-blue-800 rounded-3xl overflow-hidden flex-col sm:flex-row">
              <div className="w-full sm:w-1/2 bg-white flex flex-col justify-center items-center p-5">
                <img src={Clean} alt="Illustration" className="mb-1 hidden sm:block" />
                <p className="text-lg text-gray-700 text-center hidden sm:block">
                  Welcome to <span className="text-orange-500 font-bold">Mega Clean</span>
                </p>
                <p className="text-lg text-gray-700 text-center sm:hidden">
                  Welcome to <span className="text-orange-500 font-bold">Mega Clean</span>
                </p>
                <img src={Clean} alt="Illustration" className="sm:hidden" />
              </div>
              <div className="w-full sm:w-1/2 bg-blue-800 text-white p-8 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-6 text-center">Login</h2>
                <form onSubmit={handleLogin} className="space-y-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium">
                      Email address
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black"
                      placeholder="Enter your email"
                    />
                  </div>
                  <div className="relative">
                    <label htmlFor="password" className="block text-sm font-medium">
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black pr-10"
                      placeholder="Enter your password"
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-12 transform -translate-y-1/2 text-gray-500"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
                    </button>
                  </div>
                  <div className="flex justify-center">
                    <button
                      type="submit"
                      className="w-32 bg-red-400 text-white py-2 rounded-lg shadow-md hover:bg-orange-600 text-sm flex justify-center items-center"
                    >
                      Log in
                    </button>
                  </div>
                </form>
                {error && <p className="text-center text-sm mt-4 text-red-500">{error}</p>}
                {successMessage && (
                  <p className="text-center text-sm mt-4 text-green-500">{successMessage}</p>
                )}
                <p
                  className="text-center text-sm mt-4 text-orange-500 cursor-pointer hover:underline"
                  onClick={() => setIsPopupOpen(true)}
                >
                  Forgot password?
                </p>
              </div>
            </div>
          </div>

          {/* Popup Modal */}
          {isPopupOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Reset Password</h3>
                <form onSubmit={handleForgotPassword} className="space-y-4">
                  <div>
                    <label htmlFor="popupEmail" className="block text-sm font-medium text-gray-700">
                      Email address
                    </label>
                    <input
                      type="email"
                      id="popupEmail"
                      value={popupEmail}
                      onChange={(e) => setPopupEmail(e.target.value)}
                      className="w-full mt-2 px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 text-black"
                      placeholder="Enter your email"
                    />
                  </div>
                  {error && <p className="text-sm text-red-500">{error}</p>}
                  {successMessage && <p className="text-sm text-green-500">{successMessage}</p>}
                  <div className="flex justify-end space-x-2">
                    <button
                      type="button"
                      className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                      onClick={() => {
                        setIsPopupOpen(false);
                        setPopupEmail("");
                        setError("");
                        setSuccessMessage("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600"
                    >
                      Send Reset Link
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
     
    </div>
  );
};

export default LoginPage;







/************************************ */

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Clean from "../assets/clean.png"; // Update to the correct path for your image
// import axios from "axios";
//   const LoginPage = () => {
//     const [email, setEmail] = useState(""); // State for email input
//     const [password, setPassword] = useState(""); // State for password input
//     const [error, setError] = useState(""); // State for error message
//     const [loading, setLoading] = useState(false); // Loading state
//     const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state
//     const navigate = useNavigate(); // Hook to navigate to different routes
//     const [userType, setUserType] = useState(""); // State to store user type

//     useEffect(() => {
//       // Debugging: Log to confirm if the states are set correctly
//       console.log('isLoggedIn:', isLoggedIn, 'userType:', userType);

//       // Ensure navigation happens once login is successful and userType is set
//       if (isLoggedIn && userType) {
//         if (userType === "admin") {
//           navigate("/admin"); // Navigate to Admin page
//         } else if (userType === "staff") {
//           navigate("/staff"); // Navigate to Staff page
//         } else if (userType === "client") {
//           navigate("/user"); // Navigate to User page
//         }
//       }
//     }, [isLoggedIn, userType, navigate]); // Trigger effect when isLoggedIn or userType changes
//     const handleLogin = async (e) => {
//       e.preventDefault(); // Prevent default form submission

//       if (!email || !password) {
//         setError("Please fill in both email and password.");
//         return;
//       }

//       setLoading(true);
//       setError(""); // Reset error message

//       try {
//         // Sending API request to check login credentials
//         const response = await axios.post(
//           "http://10.27.1.112:80/megaclean/backend/api/check_login.php",
//           {
//             action: "check_login",
//             api_key: 1,
//             email: email,
//             password: password,
//           }
//         );

//         // Log the full API response to check the structure
//         console.log('Full API Response:', response.data);

//         if (response.data.status === "true") {
//           setError(""); // Reset error if login is successful

//           const userType = response.data?.usertype; // Get userType from response
//           const userId = response.data?.userId; // Get userId from response

//           console.log('User Type:', userType);
//           console.log('User ID:', userId); // Log userId

//           if (userType && userId) {
//             setUserType(userType);
//             setIsLoggedIn(true);

//             // Store userId and userType in localStorage
//             localStorage.setItem('userId', userId);
//             localStorage.setItem('userType', userType);

//             // Optionally, navigate to the respective panel
//             if (userType === 'admin') {
//               navigate("/admin");
//             } else if (userType === 'staff') {
//               navigate("/staff");
//             } else if (userType === 'client') {
//               navigate("/user");
//             }
//           } else {
//             setError("User type or user ID not found in the response.");
//           }
//         } else {
//           setError(response.data.response || "Invalid email or password.");
//         }
//       } catch (error) {
//         setError("An error occurred. Please try again later.");
//         console.error("Login error:", error.response || error);
//       } finally {
//         setLoading(false); // Reset loading state
//       }
//     };

//     return (
//       <div className="relative min-h-screen flex">
//         {/* Left Section - Gray background */}
//         <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//         <div className="absolute bottom-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//         <div className="absolute  left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//         <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//         <div className="w-1/2 bg-gray-50 flex justify-center items-center">
//           {/* You can add content here */}
//         </div>

//         {/* Right Section - Green background */}
//         <div className="w-1/2 bg-blue-600 flex justify-center items-center">
//           {/* Center the card between gray and green */}
//           <div className="absolute left-1/2 transform -translate-x-1/2 flex w-[80%] max-w-4xl shadow-lg border-4 border-blue-800 rounded-3xl overflow-hidden">
//             {/* Left Section inside the card (Gray section in the card) */}
//             <div className="w-1/2 bg-white flex flex-col justify-center items-center p-8">
//               <img src={Clean} alt="Illustration" className=" mb-6" />
//               <p className="text-lg text-gray-700 text-center">
//                 Welcome to{" "}
//                 <span className="text-orange-500 font-bold">Mega Clean</span>
//               </p>
//             </div>
//             {/* Right Section inside the card (Green section in the card) */}
//             <div className="w-1/2 bg-blue-800 text-white p-8 flex flex-col justify-center">
//               <h2 className="text-3xl font-bold mb-2">Login</h2>
//               <p className="text-sm mb-8">I'm a professional</p>
//               {/* Form to capture login details */}
//               <form onSubmit={handleLogin} className="space-y-6">
//                 <div>
//                   <label htmlFor="email" className="block text-sm font-medium">
//                     Email address
//                   </label>
//                   <input
//                     type="email"
//                     id="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)} // Update email state on change
//                     className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black"
//                     placeholder="Enter your email"
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="password" className="block text-sm font-medium">
//                     Password
//                   </label>
//                   <input
//                     type="password"
//                     id="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)} // Update password state on change
//                     className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black "
//                     placeholder="Enter your password"
//                   />
//                 </div>
//                 <div className="flex items-center">
//                   <input
//                     type="checkbox"
//                     id="remember"
//                     className="h-4 w-4 text-orange-500"
//                   />
//                   <label htmlFor="remember" className="ml-2 text-sm">
//                     Keep me logged in
//                   </label>
//                 </div>
//                 <div className="flex justify-center">
//                   <button
//                     type="submit"
//                     className="w-32 bg-red-400 text-white py-2 rounded-lg shadow-md hover:bg-orange-600 text-sm flex justify-center items-center"
//                   >
//                     Log in
//                   </button>
//                 </div>
//               </form>
//               {error && (
//                 <p className="text-center text-sm mt-4 text-red-500">{error}</p> // Display error message if any
//               )}
//               <p className="text-center text-sm mt-4 text-orange-500 cursor-pointer hover:underline">
//                 Forgot password?
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

// export default LoginPage;

// import React from "react";

// const Login = () => {
//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-500 to-purple-600">
//       <div className="bg-white p-8 rounded-lg shadow-lg w-96 animate-fade-in">
//         <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
//           Login
//         </h2>
//         <form>
//           <div className="mb-4">
//             <label
//               htmlFor="email"
//               className="block text-sm font-medium text-gray-600"
//             >
//               Email
//             </label>
//             <input
//               type="email"
//               id="email"
//               className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               placeholder="Enter your email"
//             />
//           </div>
//           <div className="mb-6">
//             <label
//               htmlFor="password"
//               className="block text-sm font-medium text-gray-600"
//             >
//               Password
//             </label>
//             <input
//               type="password"
//               id="password"
//               className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//               placeholder="Enter your password"
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition duration-300"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React from "react";
// import LoginImage from "../assets/clean.png"; // Adjust the path based on your folder structure

// const Login = () => {
//   return (
//     <div className="min-h-screen flex bg-gradient-to-r from-blue-500 to-purple-600 items-center justify-center">
//       {/* Main Container */}
//       <div className="flex w-4/5 mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
//         {/* Left Side - Image */}
//         <div className="w-1/2 p-4 flex items-center justify-center">
//           <img
//             src={LoginImage} // Imported image
//             alt="Login Illustration"
//             className="object-contain h-5/6 w-5/6 rounded-lg"
//           />
//         </div>

//         {/* Right Side - Login Form */}
//         <div className="w-1/2 p-8 flex items-center justify-center">
//           <div
//             className="w-4/5 md:w-3/4 bg-white p-8 rounded-lg shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-lg"
//           >
//             <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
//               Welcome Back
//             </h2>
//             <form>
//               <div className="mb-4">
//                 <label
//                   htmlFor="email"
//                   className="block text-sm font-medium text-gray-600"
//                 >
//                   Email
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Enter your email"
//                 />
//               </div>
//               <div className="mb-6">
//                 <label
//                   htmlFor="password"
//                   className="block text-sm font-medium text-gray-600"
//                 >
//                   Password
//                 </label>
//                 <input
//                   type="password"
//                   id="password"
//                   className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Enter your password"
//                 />
//               </div>
//               {/* Adjusted Login Button */}
//               <button
//                 type="submit"
//                 className="w-48 mx-auto py-2 bg-blue-500 text-white font-semibold rounded-full hover:bg-blue-600 transition duration-300 "
//               >
//                 Login
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React from "react";
// import LoginImage from "../assets/clean.png"; // Adjust the path based on your folder structure

// const Login = () => {
//   return (
//     <div className="min-h-screen relative bg-gradient-to-r from-blue-500 to-purple-600">
//       {/* Full Screen Image */}
//       <div className="absolute inset-0 z-0">
//         <img
//           src={LoginImage}
//           alt="Login Illustration"
//           className="object-cover w-full h-full"
//         />
//       </div>

//       {/* Main Container for Login Form */}
//       <div className="flex items-center justify-center min-h-screen relative z-10">
//         {/* Login Card with Background Opacity */}
//         <div
//           className="w-96 p-8 bg-blue-700 bg-opacity-80 rounded-lg shadow-lg"
//         >
//           <h2 className="text-2xl font-bold text-center text-white mb-6">
//             Welcome Back
//           </h2>
//           <form>
//             <div className="mb-4">
//               <label
//                 htmlFor="email"
//                 className="block text-sm font-medium text-gray-600"
//               >
//                 Email
//               </label>
//               <input
//                 type="email"
//                 id="email"
//                 className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="Enter your email"
//               />
//             </div>
//             <div className="mb-6">
//               <label
//                 htmlFor="password"
//                 className="block text-sm font-medium text-gray-600"
//               >
//                 Password
//               </label>
//               <input
//                 type="password"
//                 id="password"
//                 className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="Enter your password"
//               />
//             </div>
//             {/* Login Button */}
//             <button
//               type="submit"
//               className="w-full py-2 bg-blue-500 text-white font-semibold rounded-full hover:bg-blue-600 transition duration-300"
//             >
//               Login
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React from "react";
// import Clean from "../assets/clean.png"; // Aapka image path

// const LoginPage = () => {
//   return (
//     <div className="flex min-h-screen bg-gray-100 w-full border-4  border-blue-800">
//       <div className="bg-blue-800 shadow-lg rounded-sm flex w-full">
//         {/* Left Section */}
//         <div className="w-1/2 bg-[#F4F6F8] flex flex-col justify-center items-center p-6">
//           <img src={Clean} alt="Illustration" className="w-3/4 mb-4" />
//           <p className="text-lg text-gray-700 text-center">
//             Welcome to <span className="text-orange-500 font-bold">ProAgenda</span>
//           </p>
//         </div>
//         {/* Right Section */}
//         <div className="w-1/2 max-w-sm ml-28- p-4 text-white rounded-lg mt-60 pl-10">
//           <h2 className="text-3xl font-bold text-left mb-2">Login</h2>
//           <p className="text-sm text-left mb-10">I'm a professional</p>
//           <form className="space-y-4">
//             <div>
//               <label htmlFor="email" className="block text-sm font-medium text-gray-100 ">
//                 Email address
//               </label>
//               <input
//                 type="email"
//                 id="email"
//                 className="w-full mt-1 mb-4 px-3 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-300 bg-blue-700"
//                 placeholder="Enter your email "
//               />
//             </div>
//             <div>
//               <label htmlFor="password" className="block text-sm font-medium text-gray-100">
//                 Password
//               </label>
//               <input
//                 type="password"
//                 id="password"
//                 className="w-full mt-1 px-3 py-2  rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-300 bg-blue-700"
//                 placeholder="Enter your password"
//               />
//             </div>
//             <div className="flex items-center ">
//               <input type="checkbox" id="remember" className="h-4 w-4 " />
//               <label htmlFor="remember" className="ml-2 text-sm text-gray-100">
//                 Keep me logged in
//               </label>
//             </div>
//             <div className="flex justify-center">
//               <button
//                 type="submit"
//                 className="w-32 bg-red-400 text-white py-2 rounded-lg shadow-md hover:bg-red-500   text-sm flex justify-center items-center"
//               >
//                 Log in
//               </button>
//             </div>
//           </form>
//           <p className="text-center text-sm mt-4 text-orange-500 cursor-pointer hover:underline">
//             Forgot password?
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// useEffect(() => {
//   if (isLoggedIn) {
//     navigate("/admin"); // Navigate to admin if logged in
//   }
// }, [isLoggedIn, navigate]);

// // Function to handle login
// const handleLogin = async (e) => {
//   e.preventDefault();

//   // Ensure email and password are provided
//   if (!email || !password) {
//     setError("Please fill in both email and password.");
//     return;
//   }
//   setLoading(true); // Start loading
//   setError(""); // Reset any previous error messages
//   try {
//     const response = await axios.post(
//       "http://10.27.1.112:80/megaclean/backend/api/check_login.php",
//       {
//         action: "check_login", // Action field as required by the backend
//         api_key: 1, // Include API key in the request payload
//         email: email, // User-provided email
//         password: password, // User-provided password
//       }
//     );
//     // Log the full response for debugging
//     console.log("Response Data:", response);
//     // Handle successful login
//     if (response.data.status === "true") {
//       setError(""); // Clear error state
//       setIsLoggedIn(true); // Set login state to true
//     } else {
//       // Handle failed login
//       setError(response.data.response || "Invalid email or password.");
//     }
//   } catch (error) {
//     // Handle network or server errors
//     setError("An error occurred. Please try again later.");
//     console.error("Login error:", error.response || error);
//   } finally {
//     setLoading(false); // Stop loading spinner
//   }
// };
// Static credentials for admin login
// const validEmail = "admin@gmail.com"; // Change to your desired admin email
// const validPassword = "123"; // Change to your desired admin password

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Clean from "../assets/clean.png"; // Update to the correct path for your image
// import axios from "axios";

// const LoginPage = () => {
//   const [email, setEmail] = useState(""); // State for email input
//   const [password, setPassword] = useState(""); // State for password input
//   const [error, setError] = useState(""); // State for error message
//   const [loading, setLoading] = useState(false); // Loading state
//   const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state

//   const navigate = useNavigate(); // Hook to navigate to different routes

//   // useEffect hook to handle navigation once logged in
//   useEffect(() => {
//     if (isLoggedIn) {
//       navigate("/admin"); // Navigate to admin if logged in
//     }
//   }, [isLoggedIn, navigate]);

//   // Function to handle login
//   const handleLogin = async () => {
//     if (!email || !password) {
//       setError("Please fill in both email and password.");
//       return;
//     }

//     setLoading(true);
//     setError(""); // Reset error message before sending request

//     try {
//       console.log("Sending data to server:", { email, password });

//       const response = await axios.post(
//         "http://localhost/megaclean/backend/api/check_login.php",
//         { email, password }
//       );

//       console.log("Response Data:", response.data); // Log the full response data

//       // Clear any previous error messages when login is successful
//       if (response.data.success) {
//         setError(""); // Clear any error state if the login is successful
//         setIsLoggedIn(true); // Proceed to set logged-in state to true
//       } else {
//         // If login failed, display the error message from the server response
//         setError(response.data.message || "Invalid email or password.");
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again later.");
//       console.error("Login error:", error.response || error);
//     } finally {
//       setLoading(false); // Stop loading regardless of success or failure
//     }
//   };

//   return (
//     <div className="relative min-h-screen flex">
//       {/* Left Section - Gray background */}
//       <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//       <div className="absolute bottom-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//       <div className="absolute  left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//       <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-50"></div>
//       <div className="w-1/2 bg-gray-50 flex justify-center items-center">
//         {/* You can add content here */}
//       </div>

//       {/* Right Section - Green background */}
//       <div className="w-1/2 bg-blue-600 flex justify-center items-center">
//         {/* Center the card between gray and green */}
//         <div className="absolute left-1/2 transform -translate-x-1/2 flex w-[80%] max-w-4xl shadow-lg border-4 border-blue-800 rounded-3xl overflow-hidden">
//           {/* Left Section inside the card (Gray section in the card) */}
//           <div className="w-1/2 bg-white flex flex-col justify-center items-center p-8">
//             <img src={Clean} alt="Illustration" className=" mb-6" />
//             <p className="text-lg text-gray-700 text-center">
//               Welcome to{" "}
//               <span className="text-orange-500 font-bold">Mega Clean</span>
//             </p>
//           </div>

//           {/* Right Section inside the card (Green section in the card) */}
//           <div className="w-1/2 bg-blue-800 text-white p-8 flex flex-col justify-center">
//             <h2 className="text-3xl font-bold mb-2">Login</h2>
//             <p className="text-sm mb-8">I'm a professional</p>

//             {/* Form to capture login details */}
//             <div className="space-y-6">
//               <div>
//                 <label htmlFor="email" className="block text-sm font-medium">
//                   Email address
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)} // Update email state on change
//                   className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black"
//                   placeholder="Enter your email"
//                 />
//               </div>
//               <div>
//                 <label htmlFor="password" className="block text-sm font-medium">
//                   Password
//                 </label>
//                 <input
//                   type="password"
//                   id="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)} // Update password state on change
//                   className="w-full mt-2 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 placeholder-gray-500 text-black"
//                   placeholder="Enter your password"
//                 />
//               </div>
//               <div className="flex items-center">
//                 <input
//                   type="checkbox"
//                   id="remember"
//                   className="h-4 w-4 text-orange-500"
//                 />
//                 <label htmlFor="remember" className="ml-2 text-sm">
//                   Keep me logged in
//                 </label>
//               </div>
//               <div className="flex justify-center">
//                 <button
//                   type="button"
//                   onClick={handleLogin} // Call handleLogin on button click
//                   className="w-32 bg-red-400 text-white py-2 rounded-lg shadow-md hover:bg-orange-600 text-sm flex justify-center items-center"
//                   disabled={loading} // Disable button when loading
//                 >
//                   {loading ? "Loading..." : "Log in"}
//                 </button>
//               </div>
//             </div>
//             {error && (
//               <p className="text-center text-sm mt-4 text-red-500">{error}</p> // Display error message if any
//             )}
//             <p className="text-center text-sm mt-4 text-orange-500 cursor-pointer hover:underline">
//               Forgot password?
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;
